export const CamelCaseToName = (fieldName: string) => {
    // Convert camelCase to "Title Case"
    return fieldName
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()) // Capitalize the first letter
        .trim();
};